import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';
import commonStyles from '../../Common/commonStyles';
const styles = StyleSheet.create({
    elements: Object.assign(Object.assign({}, commonStyles.fontM), { marginHorizontal: commonStyles.marginHorizontal, paddingBottom: '2%', borderBottom: '1.5px solid #b8b8b8', marginBottom: '2%' }),
    title: {
        fontWeight: 'bold',
    },
    titleRow: Object.assign(Object.assign({}, commonStyles.flexRow), { marginBottom: '2%' }),
    mainColumn: {
        width: '30%',
    },
    sizeColumn: {
        flex: 1,
    },
    sizeRow: Object.assign(Object.assign({}, commonStyles.flexRow), { marginBottom: '1%' }),
    sizeCell: {
        fontWeight: 'bold',
    },
});
function DimensionsPage({ elements, sizes, t }) {
    return (React.createElement(View, { style: styles.elements },
        React.createElement(View, { style: styles.titleRow },
            React.createElement(View, { style: styles.mainColumn },
                React.createElement(Text, { style: styles.title }, t('product_dimensions'))),
            sizes
                .filter((s) => s.isActive)
                .map((size) => (React.createElement(View, { key: size.id, style: styles.sizeColumn },
                React.createElement(Text, null, size.name)))),
            React.createElement(View, { style: styles.sizeColumn })),
        elements.map((element) => {
            var _a;
            return (React.createElement(View, { key: element.id, style: styles.sizeRow },
                React.createElement(View, { style: styles.mainColumn },
                    React.createElement(Text, null, element.name)), (_a = element === null || element === void 0 ? void 0 : element.elementSizes) === null || _a === void 0 ? void 0 :
                _a.map((elementSize, esIdx) => {
                    var _a, _b;
                    return elementSize &&
                        ((_a = sizes.find((size) => { var _a; return size.id === ((_a = elementSize.modelSpecificationSize) === null || _a === void 0 ? void 0 : _a.id); })) === null || _a === void 0 ? void 0 : _a.isActive) && (React.createElement(View, { key: (_b = elementSize.id) !== null && _b !== void 0 ? _b : esIdx, style: styles.sizeColumn },
                        React.createElement(Text, { style: styles.sizeCell }, elementSize.dimension)));
                }),
                React.createElement(View, { style: styles.sizeColumn })));
        })));
}
export default withTranslation('specification')(DimensionsPage);
